import { Warning } from '@styled-icons/material-outlined/Warning'
import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  border: 1px solid #e04c36;
  padding: 20px 30px;
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    font-size: ${theme.font.sizes.small};
    font-weight: ${theme.font.normal};
  `}
`
export const Icone = styled(Warning)`
  color: #f4715d;
  width: 24px;
  float: left;
`
export const Title = styled.div`
  float: left;
  margin-left: 10px;
  ${({ theme }) => css`
    font-weight: ${theme.font.bold};
    font-size: ${theme.font.sizes.large};
  `};
`

export const SubTitle = styled.div`
  margin-top: 20px;
  ${({ theme }) => css`
    font-weight: ${theme.font.bold};
    color: ${theme.colors.darkGray};
  `}
`

export const Lista = styled.ol`
  margin-left: 25px;
  ${({ theme }) => css`
    color: ${theme.colors.darkGray};
  `}
`
